const DOTS = [
  { x: 91.0005, r: 3 },
  { x: 129.4, r: 1.5 },
  { x: 166.3, r: 1.5 },
  { x: 203.201, r: 1.5 },
  { x: 240.101, r: 1.5 },
  { x: 278.5, r: 3 },
  { x: 316.9, r: 1.5 },
  { x: 353.8, r: 1.5 },
  { x: 390.701, r: 1.5 },
  { x: 427.601, r: 1.5 },
  { x: 466, r: 3 },
]

type Props = {
  nfcs: number
  className?: string
}

export function NFCSGraph({ nfcs, className }: Props) {
  return (
    <svg
      width="500"
      height="404"
      viewBox="0 0 500 404"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <text
        fill="#B5BEED"
        fillOpacity="0.5"
        xmlSpace="preserve"
        style={{ whiteSpace: 'pre' }}
        fontFamily="Poppins"
        fontSize="12"
        fontWeight="500"
        letterSpacing="0.01em"
      >
        <tspan x="59" y="139.7">
          150%
        </tspan>
      </text>
      <line
        x1="91"
        y1="134.5"
        x2="465"
        y2="134.5"
        stroke="url(#paint0_linear_1991_13747)"
        strokeOpacity="0.16"
      />
      <text
        fill="#B5BEED"
        fillOpacity="0.5"
        xmlSpace="preserve"
        style={{ whiteSpace: 'pre' }}
        fontFamily="Poppins"
        fontSize="12"
        fontWeight="500"
        letterSpacing="0.01em"
      >
        <tspan x="59" y="207.7">
          100%
        </tspan>
      </text>
      <line
        x1="91"
        y1="202.5"
        x2="466"
        y2="202.5"
        stroke="url(#paint1_linear_1991_13747)"
        strokeOpacity="0.16"
      />
      <line
        x1="92"
        y1="270.733"
        x2="466"
        y2="270.733"
        stroke="url(#paint2_linear_1991_13747)"
        strokeOpacity="0.16"
      />
      <text
        fill="#B5BEED"
        fillOpacity="0.5"
        xmlSpace="preserve"
        style={{ whiteSpace: 'pre' }}
        fontFamily="Poppins"
        fontSize="12"
        fontWeight="500"
        letterSpacing="0.01em"
      >
        <tspan x="66" y="342.933">
          0
        </tspan>
      </text>
      <line
        x1="92"
        y1="337.733"
        x2="466"
        y2="337.733"
        stroke="#DED7E5"
        strokeOpacity="0.16"
      />
      <line
        x1="91.5005"
        y1="338"
        x2="91.5005"
        y2="135"
        stroke="#DED7E5"
        strokeOpacity="0.16"
      />
      <line
        x1="465.499"
        y1="338"
        x2="465.499"
        y2="135"
        stroke="url(#paint3_linear_1991_13747)"
        strokeOpacity="0.16"
      />

      <mask
        id="mask0_1991_13747"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="92"
        y="134"
        width="374"
        height="204"
      >
        <path
          d="M163.5 226.5C122.887 242.895 109.5 317.5 92.0005 335V337.767H465.999V134.5C430.5 134.5 337.871 141.994 288 152.5C179.613 175.333 218 204.5 163.5 226.5Z"
          fill="url(#paint4_linear_1991_13747)"
        />
      </mask>

      <g mask="url(#mask0_1991_13747)">
        <path
          d="M249.5 213.5C154.416 274.669 136 326.5 130 337.767H465.999V154.5C401.115 154.5 328 163 249.5 213.5Z"
          fill="url(#paint5_linear_1991_13747)"
        />
        <path
          d="M130 337.767C136 326.5 155.532 276.37 249.5 213.5C319 167 401.115 154.5 465.999 154.5"
          stroke="url(#paint6_linear_1991_13747)"
        />
      </g>

      <text
        transform="translate(0 337) rotate(-90)"
        fill="white"
        xmlSpace="preserve"
        style={{ whiteSpace: 'pre' }}
        fontFamily="Poppins"
        fontSize="12"
        fontWeight="500"
        letterSpacing="0.01em"
      >
        <tspan x="0" y="14.7">
          REQUIRED COLLATERAL AS % OF{' '}
        </tspan>
        <tspan x="0" y="35.7">
          THE LOAN SIZE
        </tspan>
      </text>
      <text
        transform="translate(92 383)"
        fill="white"
        xmlSpace="preserve"
        style={{ whiteSpace: 'pre' }}
        fontFamily="Poppins"
        fontSize="12"
        fontWeight="500"
        letterSpacing="0.01em"
      >
        <tspan x="0" y="14.7">
          SCORES
        </tspan>
      </text>

      <>
        {DOTS.map((dot, i) => (
          <circle key={i} cx={dot.x} cy="338" r={dot.r} fill="#B1A6F3" />
        ))}
      </>

      <>
        {DOTS.slice(1).map((dot, i) => {
          const curr = i + 1
          const isCurrent = Number(nfcs) === curr
          return (
            <text
              key={i}
              fill="#B5BEED"
              fillOpacity={isCurrent ? 1 : 0.5}
              xmlSpace="preserve"
              style={{ whiteSpace: 'pre' }}
              fontFamily="Poppins"
              fontSize={isCurrent ? 17 : 12}
              fontWeight="500"
              textAnchor="middle"
            >
              <tspan x={dot.x} y="367.7">
                {curr}
              </tspan>
            </text>
          )
        })}
      </>

      <line
        x1={DOTS[nfcs].x}
        y1="336"
        x2={DOTS[nfcs].x}
        y2="71"
        stroke="url(#paint7_linear_1991_13747)"
        strokeOpacity="0.16"
      />

      <defs>
        <linearGradient
          id="paint0_linear_1991_13747"
          x1="278"
          y1="89.4993"
          x2="445.38"
          y2="89.4993"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DED7E5" />
          <stop offset="1" stopColor="#DED7E5" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1991_13747"
          x1="278.5"
          y1="157.499"
          x2="446.328"
          y2="157.499"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DED7E5" />
          <stop offset="1" stopColor="#DED7E5" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1991_13747"
          x1="279"
          y1="225.732"
          x2="446.38"
          y2="225.732"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DED7E5" />
          <stop offset="1" stopColor="#DED7E5" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1991_13747"
          x1="420.498"
          y1="236.5"
          x2="420.498"
          y2="145.649"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DED7E5" />
          <stop offset="1" stopColor="#DED7E5" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1991_13747"
          x1="338"
          y1="271"
          x2="482"
          y2="269"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0326773" />
          <stop offset="0.890621" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_1991_13747"
          x1="279"
          y1="144"
          x2="269.668"
          y2="420.291"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0326773" stopColor="#FF3D6B" stopOpacity="0.5" />
          <stop offset="0.218718" stopColor="#FFC93D" stopOpacity="0.5" />
          <stop offset="0.52372" stopColor="#40FCAD" stopOpacity="0.2" />
          <stop offset="0.890621" stopColor="#40FCAD" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_1991_13747"
          x1="163"
          y1="329"
          x2="312.9"
          y2="103.06"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#40FCAD" />
          <stop offset="0.433396" stopColor="#FFC93D" />
          <stop offset="0.622947" stopColor="#FF3D6B" />
          <stop offset="0.957253" stopColor="#FF3D6B" stopOpacity="0.16" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_1991_13747"
          x1="158.499"
          y1="203.5"
          x2="158.499"
          y2="84.9016"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DED7E5" />
          <stop offset="1" stopColor="#DED7E5" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
}
